import React from "react";
import styled, { keyframes, css } from "styled-components";
import { connect } from "react-redux";
import idx from "idx";

import FailureScreen from "../../FailureScreen";
import thProjectInner from "./spinner-thProject/spinner-inner.png";
import thProjectOuter from "./spinner-thProject/spinner-outer.png";
import ThemeProvider from "../../ThemeProvider";

const IronOuter = ({ fill = "#fff" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 304 303.999">
    <defs>
      <clipPath id="clip-path">
        <path
          d="M-3550,129c-83.813,0-152-68.187-152-152s68.187-152,152-152,152,68.186,152,152S-3466.187,129-3550,129Zm0-297c-79.954,0-145,65.046-145,145s65.047,145,145,145,145-65.047,145-145S-3470.047-168-3550-168Z"
          transform="translate(3702 175)"
        />
      </clipPath>
      <linearGradient
        id="linear-gradient"
        x1="0.5"
        x2="0.5"
        y2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor={fill} stopOpacity="0" />
        <stop offset="1" stopColor={fill} />
      </linearGradient>
    </defs>
    <g transform="translate(-531 -398)">
      <g clipPath="url(#clip-path)" transform="translate(531 398)">
        <g transform="translate(0 0)">
          <path
            fill="url(#linear-gradient)"
            d="M0,0H160.1V304H0Z"
            transform="translate(143.9)"
          />
          <path fill={fill} d="M0,0H152V304H0Z" />
          <path
            fill="url(#linear-gradient)"
            d="M0,0H160.1V128.2H0Z"
            transform="translate(143.9 175.8)"
          />
        </g>
      </g>
    </g>
  </svg>
);

const IronInner = ({ width = 65, height = 65, fill = "#fff" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 31.55 31.549"
    fill={fill}
    width={width}
    height={height}
  >
    <g>
      <path
        d="M2829.083-806.423l-1.452-1.452,3.224-3.223-2.617-2.617,6.924-6.924,2.617,2.616,3.209-3.21,1.452,1.453-3.209,3.209,2.617,2.617-6.924,6.924-2.616-2.616-3.223,3.223Zm2.109-7.341,3.78,3.78,3.915-3.915-3.78-3.78Z"
        transform="translate(-2810.891 833.72)"
      />
      <path
        d="M2456.1-982.553l3.227-3.227-2.618-2.62,15.258-15.258,2.618,2.62,3.107-3.107,1.456,1.456-3.107,3.107,2.609,2.611-15.258,15.258-2.61-2.611-3.227,3.227Z"
        transform="translate(-2456.101 1008.391)"
      />
    </g>
  </svg>
);

const EzInner = ({ fill = "#FFD503", width = 65, height = 65 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 25.8 25.7"
    fill={fill}
  >
    <g>
      <polygon
        points="25.6,12.5 24.3,11.2 14.5,1.5 13,0 11.5,1.5 8.5,4.5 7.6,5.4 8.9,6.7 9.4,6.7 12.3,6.7 10.9,5.2 
 11.5,4.5 13,3 22.7,12.6 21.9,13.4 20.6,14.7 12.8,14.7 11.4,13.2 8.4,13.2 9.8,14.7 11.9,16.8 13.2,16.8 21.5,16.8 22.8,15.5 
 22.8,15.5 23.6,14.7 25,13.3 25.8,12.6 	"
      />
      <polygon
        points="16.8,19 16.3,19 13.5,19 14.8,20.5 14.3,21.1 12.8,22.7 3,13 5.1,10.9 5.3,10.8 13,10.8 14.5,12.2 
 17.5,12.2 16.1,10.8 14,8.7 12.8,8.7 4.3,8.7 4.3,8.8 2.3,10.9 2.1,11 0,13 0.1,13.1 1.5,14.5 11.3,24.2 12.8,25.7 14.3,24.2 
 17.3,21.1 18.1,20.2 	"
      />
    </g>
  </svg>
);

const rotate360 = keyframes`
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Container = styled.div`
  ${process.env.REACT_APP_DEPLOY_TARGET === "siamoption" &&
    css`
      background-color: ${({ theme }) => theme.main};
    `};
  ${process.env.REACT_APP_DEPLOY_TARGET === "eztrader" &&
    css`
      background-color: #222127;
    `};
  ${process.env.REACT_APP_DEPLOY_TARGET === "irontrade" &&
    css`
      background-color: ${({ currency }) =>
        currency === "THB" ? "#362f42" : "#fff"};
    `};
  ${({ currency }) =>
    process.env.REACT_APP_DEPLOY_TARGET === "irontrade" &&
    currency != null &&
    currency !== "THB" &&
    css`
      background-image: linear-gradient(#1b546a 0%, #399177 100%);
    `};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
`;

const Bg = styled.div`
  background: center no-repeat;
  background-size: contain;
`;

const Spinner = styled(Bg)`
  position: relative;
  width: 108px;
  height: 108px;
  min-width: 108px;
  ${() =>
    process.env.REACT_APP_DEPLOY_TARGET === "siamoption" &&
    css`
      background-image: url(${thProjectInner});
      border-radius: 50%;
    `};
  ${() =>
    (process.env.REACT_APP_DEPLOY_TARGET === "irontrade" ||
      process.env.REACT_APP_DEPLOY_TARGET === "eztrader") &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
    `};
`;

const Inner = styled(Bg)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: ${() =>
    process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
      ? "none"
      : `url(${thProjectOuter})`};
  animation: ${rotate360} 1.2s ease-out infinite;
  transform-origin: 50%;
`;

class BrandSpinner extends React.Component {
  state = {
    timeout: false,
  };

  constructor(props) {
    super(props);

    const timeout = 30000;
    this.timer = setTimeout(() => {
      this.setState({ timeout: true });
    }, timeout);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
    this.timer = null;
  }

  render() {
    if (this.state.timeout) {
      return <FailureScreen />;
    }

    const currency = idx(this.props, (_) => _.profile.currency);
    const ironThemeLikeTh =
      process.env.REACT_APP_DEPLOY_TARGET === "irontrade" && currency === "THB";
    const ironSpinnerColor =
      currency == null || this.props.isColor
        ? "#3b9478"
        : ironThemeLikeTh
        ? "#FEAC00"
        : "#fff";

    return (
      <ThemeProvider>
        <Container currency={currency}>
          <Spinner>
            {process.env.REACT_APP_DEPLOY_TARGET === "irontrade" && (
              <IronInner width={65} height={65} fill={ironSpinnerColor} />
            )}
            {process.env.REACT_APP_DEPLOY_TARGET === "eztrader" && <EzInner />}
            <Inner>
              {process.env.REACT_APP_DEPLOY_TARGET === "irontrade" && (
                <IronOuter fill={ironSpinnerColor} />
              )}
            </Inner>
          </Spinner>
        </Container>
      </ThemeProvider>
    );
  }
}

export default connect((state) => {
  return {
    profile: state.profile,
  };
})(BrandSpinner);



// WEBPACK FOOTER //
// ./src/components/Spinners/BrandSpinner/index.js